/** HOMEPAGE Scripts */

document.addEventListener('DOMContentLoaded', function() {
    const starRatings = document.querySelectorAll('.item-sticker .star-rating');
    starRatings.forEach(rating => {
        const stars = rating.querySelectorAll('.star');
        const ratingValue = parseFloat(rating.getAttribute('data-rating'));

        stars.forEach((star, index) => {
            const filledStar = star.querySelector('.star-filled');
            if (index < Math.floor(ratingValue)) {
                filledStar.style.width = '100%';
            } else if (index === Math.floor(ratingValue)) {
                filledStar.style.width = `${(ratingValue - index) * 100}%`;
            } else {
                filledStar.style.width = '0';
            }
        });
    });
});



// var swiper = new Swiper(".image-slider-image_slide_f4fEqH", {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   pagination: {
//     el: ".swiper-pagination-image_slide_f4fEqH",
//     dynamicBullets: true,
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next-image_slide_f4fEqH",
//     prevEl: ".swiper-button-prev-image_slide_f4fEqH",
//   },
//   breakpoints: {
//     768: {
//       slidesPerView: 2.6,
//     }
//   },
// });






  